<template>
    <v-container fluid>
        <v-row class="ma-4">
            <v-card-title>
                <span class="headline">Бригады и ДПФ за {{ get_prev_date() }}</span>
            </v-card-title>
            <v-dialog v-model="group" persistent width="80vw">
                <!-- <template v-slot:activator="{ on, attrs }">
                    <v-btn color="warning" dark v-bind="attrs" v-on="on">Создать Бригаду</v-btn>
                </template> -->
                <v-card>

                    <v-card-title>
                        <span class="headline">ДПФ бригады</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field label="Название бригады*" :disabled="true" required v-model="selected_brigade.name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field label="ДПФ*"  required v-model="selected_brigade.value" type="input"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="group = false">Закрыть</v-btn>
                        <v-btn color="warning" dark @click="save_dpf()">Сохранить</v-btn>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </v-row>
        <div class="groups-grid">
                <v-card class="mb-6 mr-4" v-for="(group, ind) in get_bridades_by_date" :key="ind" @click="test(group)">
                    <v-card-title>
                        <div class="mr-4">{{ group.name }}</div>
                    </v-card-title>
                    
                    <v-card-text v-if="group.brigade_statistic.length">
                      {{group.brigade_statistic[0].dpf}}
                    </v-card-text>
                    <v-card-text v-else>
                      0
                    </v-card-text>
                </v-card>
        </div>
    </v-container>
</template>

<script>

// import SubGroup from '@/components/sub_groups/SubGroup.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'SubGroupView',
    data: () => ({
      group: false,
      sub_group_name: null,
      sub_group_type: null,
      prev_date: null,
      selected_brigade: {

      },
      sub_groups: [
            {
                type: 'product',
                name: 'Продукт'
            },
            {
                type: 'accessory',
                name: 'Комплектующая'
            },
      ]
     
    }),
    components:{
        // SubGroup
    },
    created () {
        this.load_bridades_by_date(this.$route.params.date)
    },
    computed: {
        ...mapGetters([
             'get_bridades_by_date', 'get_baseURL'
        ]),
    },
    methods: {
        ...mapActions([
            'load_bridades_by_date', 'update_dpf'
        ]),

        test(brigade){
            this.selected_brigade = {}
            this.selected_brigade = brigade
            this.selected_brigade.value = brigade?.brigade_statistic[0]?.dpf ?? 0
            this.group = true
        },

        get_prev_date(){
            var date = new Date(this.$route.params.date);
            date.setDate(date.getDate() - 1);
            this.prev_date = date.toISOString().split('T')[0]
           return new Date(date).toLocaleDateString('ru-RU') 
        },
        
        save_group(){
            if(!this.selected_brigade.name || !this.selected_brigade.value) return false

            this.create_sub_group({name : this.sub_group_name, type: this.sub_group_type.type })
            .then(() => {
                this.sub_group_name = null
                this.group = false
            }).catch(err => {
                console.log(err);
            })
        },
        save_dpf(){
            if(!this.selected_brigade.name || !this.selected_brigade.value) return false

            this.update_dpf({date : this.prev_date, dpf: this.selected_brigade.value , brigade: this.selected_brigade._id})
            .then(() => {
                this.sub_group_name = null
                this.group = false
            }).catch(err => {
                console.log(err);
            })
        },
        
    },
}
</script>

<style>
.groups-grid{
    display: grid;
    grid-template-columns: repeat(auto-fit, 1fr);
    grid-gap: 1rem;
    width: 100%;
}

.products-grid{
    flex-wrap: wrap;
    display: flex;
    gap: 15px;
}

.blocks-list{
    display: grid;
    grid-template-columns: repeat(auto-fit, 192px);
    grid-gap: 1rem;
    margin: 20px
}
</style>